import React from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailSignupModal from "./EmailSignupModal";
import sharif1 from "../images/georgiaNative.jpg";
import sharif1b from "../images/georgiaNative2.jpg";
import sharif2 from "../images/familyPortrait.jpg";
import sharif2a from "../images/familyPortrait2.jpg";
import sharif2b from "../images/familyPortrait3.jpg";
import howardGraduation from "../images/howardGraduation.jpg";
import howardGraduationb from "../images/howardGraduation2.jpg";
import servantLeader from "../images/servantLeader.jpg";
import servantLeaderb from "../images/servantLeader2.jpg";
import targetImage from "../images/MeetSharifHeader.jpg";
import { useState } from "react";
const MeetSharif = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);
  return (
    <Box sx={{ backgroundColor: "#FFFDF7!important" }}>
      {/* Header Section */}
      <Box
        sx={{
          backgroundImage: `url(${targetImage})`,

          backgroundSize: "cover",
          backgroundPosition: isMobile ? "center" : "top",
          backgroundRepeat: "no-repeat",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
            },
          }}
        >
          About Sharif
        </Typography>
      </Box>
      {/* Body Section */}
      <Box p={isMobile ? "0 16px" : "96px 96px 48px"}>
        <Grid container alignItems="flex-start">
          {/* Georgia Native Section */}
          <Grid container className="section-wrap" mt={0} mb={isMobile ? 2 : 0}>
            <Grid
              item
              display="flex"
              flexDirection="column"
              xs={12}
              md={5}
              my={isMobile ? 2 : 0}
            >
              <img
                src={sharif1}
                alt="Sharif community"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={1.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5.5}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "#014991!important",
                }}
              >
                Sharif Hidayat grew up in Rockville and has dedicated life to
                public service. He attended Montgomery County public schools,
                then graduated from the University of Maryland College Park with
                a degree in Government and Politics with a minor in Leadership.
                <br></br>
                <br></br>
                After graduation, he served our community for over 20 years as
                an officer with the Montgomery County Police Department. As the
                community services officer for the 4th District Police Station
                in Wheaton, he worked with Home owners associations,
                Non-profits, Civic Associations, Houses of Worship and the
                business community to solve chronic problems in the community.
                He developed relationships with government organizations such as
                permitting services, housing code enforcement, animal services
                and the Office of environmental protection. Sharif worked with
                these organizations to help solve community based, quality of
                life issues.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={0.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Graduation Section */}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={0.25}
              my={4}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "#106cb7!important",
                }}
              >
                “My approach has always been that people had the right to the
                peaceful enjoyment of their home and community. If people,
                organizations and or businesses were disturbing that fundamental
                right, I was going to be on the case.”
                <br></br>
                <br></br>
                Sharif solved cases by working with the relationships he
                developed in the community and as a result they trusted him with
                vital information.
                <br></br>
                <br></br>
                Some notable cases are listed here:
                <List>
                  <ListItemButton
                    component="a"
                    href="https://www.nbcwashington.com/news/local/man-accused-of-targeting-disabled-for-theft/1907802/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      background: "#106cb7",
                      borderRadius: "4px",
                      "&:hover": {
                        "& .MuiListItemText-primary": { color: "#106cb7" },
                      },
                      mb: 1,
                    }}
                  >
                    <ListItemText
                      sx={{ color: "#FFF" }}
                      primary="Man Accused of Targeting Disabled for Theft"
                    />
                  </ListItemButton>
                  <ListItemButton
                    component="a"
                    href="https://www2.montgomerycountymd.gov/mcgportalapps/Press_Detail_Pol.aspx?Item_ID=28528"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      background: "#106cb7",
                      borderRadius: "4px",
                      "&:hover": {
                        "& .MuiListItemText-primary": { color: "#106cb7" },
                      },
                      mb: 1,
                    }}
                  >
                    <ListItemText
                      sx={{ color: "#FFF" }}
                      primary="Officers and State's Attorneys Receive Anti-Defamation League SHIELD Award"
                    />
                  </ListItemButton>
                </List>
                His career excelled as he went after individuals that victimized
                the most vulnerable in our community.
                <List>
                  <ListItemButton
                    component="a"
                    href="https://wjla.com/news/crime/police-landlord-hired-thugs-to-threaten-scare-his-renters-force-them-to-leave-106323"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      background: "#106cb7",
                      borderRadius: "4px",
                      "&:hover": {
                        "& .MuiListItemText-primary": { color: "#106cb7" },
                      },
                      mb: 1,
                    }}
                  >
                    <ListItemText
                      sx={{ color: "#FFF" }}
                      primary="Montgomery County landlord hired thugs to scare renters, force them to leave"
                    />
                  </ListItemButton>
                </List>
                While working for the police department, he started flying
                lessons and then became a flight instructor — teaching students
                out of the Gaithersburg Airpark. One of his successes was a 16
                year old student from Damascus that soloed an airplane on his
                16th birthday.
                <List>
                  <ListItemButton
                    component="a"
                    href="https://www.somdnews.com/archive/news/boy-16-pilots-plane-solo-for-first-time-at-montgomery-county-airpark/article_4415227f-c1c5-5366-b53a-aee312135632.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      background: "#106cb7",
                      borderRadius: "4px",
                      "&:hover": {
                        "& .MuiListItemText-primary": { color: "#106cb7" },
                      },
                      mb: 1,
                    }}
                  >
                    <ListItemText
                      sx={{ color: "#FFF" }}
                      primary="Boy, 16, pilots plane solo for first time at Montgomery County Airpark"
                    />
                  </ListItemButton>
                </List>
                This young man is now at Southwest Airlines, working as a pilot.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={1.25}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5}
              display="flex"
              flexDirection="column"
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <img
                src={howardGraduation}
                alt="Sharif speaking"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
          </Grid>
          {/* Capital Hill Section */}
          <Grid container className="section-wrap" my={isMobile ? 2 : 0}>
            <Grid
              display="flex"
              flexDirection="column"
              item
              xs={12}
              md={5}
              my={isMobile ? 2 : 0}
            >
              <img
                src={sharif2}
                alt="Sharif community"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={1.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5.5}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "#014991!important",
                }}
              >
                Sharif also wanted to get troubled youth out of a life of crime
                and give them exposure to aviation opportunities. As a
                volunteer, he joined Our house in Olney and flew a helicopter to
                the Montgomery County Airpark to talk to the young boys about
                how to get their lives on a better trajectory via aviation
                opportunities. The mentee that showed the most improvement got
                to fly an airplane with him.
                <br></br>
                <br></br>
                Currently, he is a pilot for American Airlines based out of Reagan National.
                <br></br>
                <br></br>
                He is active with his kids PTA at Laytonsville Elementary School
                and serves as a delegate from our school on the MCCPTA.
                <br></br>
                <br></br>
                Sharif has also mentored kids that were enrolled in the State’s Attorneys Office's
                truancy court program. The goal was to keep them in school
                instead of being on the streets where they could get in trouble.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={0.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          mb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#106cb7!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/SharifHidayat320/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/votesharif2026"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/VoteSharifDistrict7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By authority: Friends of Sharif Hidayat; Cody Hidayat, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};
export default MeetSharif;
